import { useState } from "react";
import { Button } from "@jugl-web/ui-components/cross-platform/Button";
import { useTranslations, cx } from "@jugl-web/utils";
import { useBoardTemplatesModalProvider } from "@jugl-web/domain-resources/tasks/components/BoardTemplatesModal/providers/useBoardTemplatesModalProvider";
import { BoardTemplate } from "@jugl-web/rest-api/tasks";

export const BoardTemplatesCard = ({ name, desc, id, img }: BoardTemplate) => {
  const [isHovered, setIsHovered] = useState(false);
  const { setSelectedTemplate, handleUseTemplate } =
    useBoardTemplatesModalProvider();
  const { t } = useTranslations();
  return (
    <div
      className="relative flex h-[360px] w-[320px] flex-col items-start overflow-hidden rounded-lg border border-solid border-[#DFE2E3] bg-white p-4 font-secondary transition-all"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="rounded-lg border-[1px] border-solid border-[#E4E4E4] transition-all duration-500"
        style={{
          backgroundImage: `url(${img})`,
          width: "100%",
          height: isHovered ? "103.5px" : "157.5px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      />
      <div
        className="w-full truncate pt-5 pb-4 text-xl font-medium text-black"
        title={name}
      >
        {name}
      </div>
      <div
        title={desc}
        className="line-clamp-4 max-h-[76px] w-full overflow-hidden text-sm leading-[135%] text-ellipsis text-[#828282]"
      >
        {desc}
      </div>

      <div
        className={cx(
          "absolute right-0 bottom-5 left-0 flex justify-center gap-5 transition-all duration-500",
          {
            "bottom-[-50px]": !isHovered,
          }
        )}
      >
        <Button
          className="h-[40px] w-[130px] font-medium"
          variant="contained"
          color="grey"
          onClick={() => setSelectedTemplate(id)}
        >
          {t({
            id: "board-templates-card.learn-more",
            defaultMessage: "Learn More",
          })}
        </Button>
        <Button
          className="h-[40px] w-[130px] font-medium whitespace-nowrap"
          onClick={() => handleUseTemplate(id)}
        >
          {t({
            id: "board-templates-card.use-template",
            defaultMessage: "Use Template",
          })}
        </Button>
      </div>
    </div>
  );
};
